import { LocaleLink } from "@/components/site/LocaleLink";
import type { WpPost } from "@/server/wp.server";
import { useT } from "@/lib/i18n/I18nProvider";
import { PostByline } from "@/components/insights/PostByline";

function stripHtml(html: string) {
  return html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}

export function PostCard({ post }: { post: WpPost }) {
  const { locale } = useT();
  const media = post._embedded?.["wp:featuredmedia"]?.[0];
  const term = post._embedded?.["wp:term"]?.[0]?.[0];
  return (
    <LocaleLink
      to="/blog/$slug"
      params={{ slug: post.slug }}
      className="group block overflow-hidden rounded-2xl border border-border/60 bg-background transition-all hover:-translate-y-0.5 hover:shadow-soft"
    >
      {media?.source_url ? (
        <div className="aspect-[16/9] overflow-hidden bg-secondary">
          <img
            src={media.source_url}
            alt={media.alt_text || stripHtml(post.title.rendered)}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </div>
      ) : (
        <div className="aspect-[16/9] bg-gradient-brand opacity-80" />
      )}
      <div className="p-5">
        {term && (
          <p className="text-[12px] font-medium text-accent">{term.name}</p>
        )}
        <h3
          className="font-display mt-2 text-[18px] font-medium leading-snug text-foreground"
        >
          {stripHtml(post.title.rendered)}
        </h3>
        <p className="mt-2 line-clamp-2 text-[13px] text-foreground/70">
          {stripHtml(post.excerpt.rendered)}
        </p>
        <PostByline
          date={post.date}
          locale={locale}
          compact
          className="mt-4"
        />
      </div>
    </LocaleLink>
  );
}